import { render, staticRenderFns } from "./registerPassWord.vue?vue&type=template&id=564d962e&scoped=true"
import script from "./registerPassWord.vue?vue&type=script&lang=js"
export * from "./registerPassWord.vue?vue&type=script&lang=js"
import style0 from "./registerPassWord.vue?vue&type=style&index=0&id=564d962e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d962e",
  null
  
)

export default component.exports